/*eslint-disable no-undef */
import phina from 'phina.js'
// import config from '../config'

export default ()=>{

phina.define("MainScene", {
  superClass : "phina.display.DisplayScene",
  init : function(param) {
    param=(param||{}).$safe(MainScene.defaults)
    this.superInit({ width:param.width, height:param.height });

    phina.display.Sprite('img/ui/bg.png')
    .setPosition(500,300)
    .addChildTo(this)

    // this.versionLabel = phina.display.Label({
    //   text:'version {0}'.format(config.version),
    //   fill:'#000', fontSize:18
    // }).setPosition(900,590)
    // .addChildTo(this)
  },
  _static:{
    defaults: {
      width:1000, height:600
    }
  }
});

}